module.exports = __webpack_public_path__ + "img/capa_11.b600bf63.jpg";